module.exports = __webpack_public_path__ + "a413511e9103662d50a158f0f8a256be.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/etsy_2023_chart.png
// module id = 1672
// module chunks = 0